import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const video = {
  cheatVideo: lazyModuleMethod(() => import('./cheatVideo'), 'default'),
  fetchVideoArticles: lazyModuleMethod(
    () => import('./fetchVideoArticles'),
    'default'
  ),
  fetchVideoFrames: lazyModuleMethod(
    () => import('./fetchVideoFrames'),
    'default'
  ),
  createVideoDistribution: lazyModuleMethod(
    () => import('./createVideoDistribution'),
    'default'
  ),
  editVideoDistribution: lazyModuleMethod(
    () => import('./editVideoDistribution'),
    'default'
  ),
  fetchStatisticsVideo: lazyModuleMethod(
    () => import('./fetchStatisticsVideo'),
    'default'
  ),
}
